import { useTranslation } from 'react-i18next';

import { UserGroupsDataGrid } from '~features/userGroups';
import UserGroupsOverviewContainer from '~features/userGroups/containers/userGroupsOverviewContainer';

import Page from '../page';

const UserGroupsPage = () => {
	const { t } = useTranslation();

	return (
		<Page title={t('userGroups')}>
			<UserGroupsOverviewContainer />
		</Page>
	);
};

export default UserGroupsPage;
